<template>
  <div>
    <v-card
      ><v-card-title class="text-subtitle-1">
        <div><b>Published Date</b></div>
        : {{ publishDate }}
      </v-card-title>
      <v-card-text>
        <v-btn color="primary" text @click="viewPdf"
          ><v-icon>mdi-file-pdf-box</v-icon> View pdf</v-btn
        >
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          text
          @click="showDeleteDialog = true"
          :loading="isDeleting"
          >Delete</v-btn
        >
        <v-btn color="primary" text @click="showPdfDialog = true">Edit</v-btn>
      </v-card-actions>
    </v-card>
    <confirm-delete-dialog
      :visible="showDeleteDialog"
      @close="showDeleteDialog = false"
      @confirmAction="deletePDF"
    />
    <edit-pdf-dialog
      :pdf="pdf"
      :visible="showPdfDialog"
      @close="showPdfDialog = false"
      @refresh="$emit('refresh')"
    />
  </div>
</template>
<script>
import * as dateFormats from '@/constants/dateFormats'
import ConfirmDeleteDialog from './ConfirmDeleteDialog.vue'
import pdfApi from '@/api/pdfApi'
import snackbar from '@/utils/snackbar'
import EditPdfDialog from './EditPdfDialog.vue'

export default {
  components: { ConfirmDeleteDialog, EditPdfDialog },
  props: {
    pdf: {
      type: Object,
      required: true,
      default: null
    }
  },
  data () {
    return {
      showDeleteDialog: false,
      isDeleting: false,
      showPdfDialog: false
    }
  },
  computed: {
    publishDate () {
      return this.$moment(this.pdf.publish_date).format(
        dateFormats.FRIENDLY_DATE_2
      )
    }
  },
  methods: {
    async deletePDF (data) {
      try {
        this.isDeleting = true
        const r = await pdfApi.deletePdf({
          id: this.pdf.id
        })
        if (r.data === 1) {
          snackbar.show('PDF Deleted successfully', 'success')
          this.$emit('refresh')
        }
      } finally {
        this.isDeleting = false
      }
    },
    viewPdf () {
      this.$log.info('pdf ', [this.pdf.path])
      window.open(process.env.VUE_APP_API_BASE_URL + '/pdf/' + this.pdf.id)
    }
  }
}
</script>
